import { render, staticRenderFns } from "./BloodPressData.vue?vue&type=template&id=c6c59080&scoped=true"
import script from "./BloodPressData.vue?vue&type=script&lang=js"
export * from "./BloodPressData.vue?vue&type=script&lang=js"
import style0 from "./BloodPressData.vue?vue&type=style&index=0&id=c6c59080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c59080",
  null
  
)

export default component.exports